import {
    Avatar,
    Box,
    Button,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    Stack,
    Tooltip,
    Typography, } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import Logout from '@mui/icons-material/Logout';
import { useTheme, } from '@mui/material/styles';
import { useAppbar, useAuth, useLogout, } from '../../hooks';
import ColorModeSwitches from './ColorModeSwitches';
import SimpleBackdrop from '../simple-backdrop';

export default function AccountMenu() {
    const theme = useTheme();
    const { anchorElUser, userMenuOpen, userMenuClose, } = useAppbar();
    const { user, } = useAuth();
    const { logout, isPending, } = useLogout();

    const handleLogout = async () => {
        await logout();
        userMenuClose();
    };

    return (
        <Box>
            <Stack
                direction='row'
                alignItems='center'
                spacing={1.5}
                sx={{
                    border: 1,
                    borderColor: 'borderColor.main',
                    pl: 1.5,
                    '&:hover': {
                        borderColor: 'secondary.main',
                        '& .MuiAvatar-root': {
                            color: 'secondary.main',
                        },
                        '& .MuiTypography-root': {
                            color: 'secondary.main',
                        },
                    },
                }}
            >
                <Typography
                    variant='cropped'
                    sx={{
                        color: 'text.primary',
                        cursor: 'default',
                        fontSize: 14,
                        fontWeight: 500,
                        maxWidth: [80, 300, 500, 250],
                    }}>{ user?.displayName }</Typography>
                <Tooltip title='Настройки аккаунта' placement='bottom' arrow>
                    <IconButton
                        aria-haspopup='true'
                        aria-controls='user-menu-appbar'
                        aria-label='Open the user menu'
                        onClick={(event) => userMenuOpen(event)}
                        sx={{ p: 0, }}>
                        <Avatar alt='Avatar' sx={{ borderRadius: 0, height: [33, 36, 39], width: [33, 36, 39], }}>
                            <ManageAccountsIcon sx={{fontSize: [20, 22, 24, 26]}} />
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Stack>
            <Menu
                id='user-menu-appbar'
                anchorEl={anchorElUser}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
                keepMounted
                open={Boolean(anchorElUser)}
                onClose={userMenuClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        border: 1,
                        borderColor: 'borderColor.main',
                        boxShadow: 2,
                        minWidth: 250,
                        maxWidth: [276, 300, 325, 350],
                        ml: '1px',
                        mt: ['36px', '43px',],
                        overflow: 'visible',
                        '&:hover': {
                            boxShadow: 5,
                        },
                    },
                }}
                sx={{
                    '& .MuiMenuItem-root': {
                        '&:hover': {
                            bgcolor: 'transparent',
                            '& .MuiButton-root': {
                                color: 'secondary.main',
                            },
                        }
                    },
                    '& .MuiButton-root': {
                        fontSize: 15,
                        fontWeight: 400,
                        p: 0,
                    },
                    '& .MuiListItemIcon-root, & .MuiButton-root': {
                        color: 'text.primary',
                    },
                }}
            >
                <MenuItem sx={{
                    '&:hover': {
                        cursor: 'default',
                    },
                }}>
                    <Stack
                        direction='row'
                        alignItems='center'
                        sx={{ width: '100%', }}>
                        <ListItemIcon>
                            { theme.palette.mode === 'light' ? <DarkModeOutlinedIcon fontSize='small' /> : <DarkModeIcon fontSize='small' /> }
                        </ListItemIcon>
                        <Typography variant='cropped' sx={{ fontSize: 14, maxWidth: [148, 172, 197, 222], }}>Тёмный режим</Typography>
                        <ColorModeSwitches />
                    </Stack>
                </MenuItem>
                <MenuItem sx={{ flexDirection: 'column', }}>
                    <Button
                        fullWidth
                        startIcon={<Logout fontSize='small' sx={{mr: 0.9,}} />}
                        onClick={handleLogout}
                        sx={{
                            fontSize: 14,
                            justifyContent: 'flex-start',
                            ml: 1.25,
                            '&:hover': {
                                bgcolor: 'transparent',
                            },
                        }}
                    >{isPending ? 'Выходим...' : 'Выйти'}</Button>
                </MenuItem>
            </Menu>
            <SimpleBackdrop open={isPending} />
        </Box>
    );
}